module.exports = __webpack_public_path__ + "img/feedback2.c3767f4b.webp";